import { Component } from '@angular/core';
import { HelpTextService } from '../common-components/help-text/service/help-text.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  latestBuildDateTime: string = '';
  constructor(private helpTextService: HelpTextService,private datePipe: DatePipe) {

    this.helpTextService.getBuildVersion().subscribe((buildDate: BuildVersion | null) => {
      this.latestBuildDateTime = buildDate?.updatedAt || '';
      //Build: Thu Jan 08 2026 09:29:36 GMT-0800 (Pacific Standard Time) GMT-0700 (Pacific Daylight Time) if we use
      // buildDate && new Date(buildDate?.updatedAt).toString() 
    });
  }
}
export interface BuildVersion {
  workflowId: number
  updatedAt: string
}
